var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkPointsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1834 6.04158C14.3084 2.19159 10.9501 0.458252 8.00008 0.458252C8.00008 0.458252 8.00008 0.458252 7.99175 0.458252C5.05008 0.458252 1.68341 2.18325 0.808413 6.03325C-0.166587 10.3333 2.46675 13.9749 4.85008 16.2666C5.73341 17.1166 6.86675 17.5416 8.00008 17.5416C9.13341 17.5416 10.2667 17.1166 11.1417 16.2666C13.5251 13.9749 16.1584 10.3416 15.1834 6.04158ZM8.00008 10.2166C6.55008 10.2166 5.37508 9.04158 5.37508 7.59159C5.37508 6.14158 6.55008 4.96658 8.00008 4.96658C9.45008 4.96658 10.6251 6.14158 10.6251 7.59159C10.6251 9.04158 9.45008 10.2166 8.00008 10.2166Z",
    fill: "#8E99A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPointsIcon);
export default __webpack_public_path__ + "static/media/WorkPointsIcon.f0dbc257cf80d496d69181b2c60a4a9f.svg";
export { ForwardRef as ReactComponent };